<template>
  <div class="sc-sale-commodity">
    <LatestUpdateTime style="margin: 30px auto 20px auto;" v-if="date" :date="date" />
    <div class="split"></div>
    <div class="inner">
      <div class="title">
        <div class="left">
          <img class="icon" src="@/assets/圆圈.png" alt />
          <div class="name">全国销售数据</div>
        </div>
        <div class="right">
          <ScDatePicker v-if="date" :date="date" @change="onChange" />
        </div>
      </div>

      <div class="data-select">
        <div :class="aActive ? 'a a-shadow' : 'a'" @click="aActive = true">
          <img src="@/assets/dashboard/全国销售数量(KG).png" />

          <div class="text">
            <div class="key">全国销售数量({{head.unit}})</div>
            <div class="value">{{util.formatMoney(head.quantity, 2, "")}}</div>
          </div>
        </div>
        <div :class="aActive ? 'b' : 'b b-shadow'" @click="aActive = false">
          <img src="@/assets/dashboard/全国销售额(元).png" />

          <div class="text">
            <div class="key">全国销售额(元)</div>
            <div class="value">{{util.formatMoney(head.amount, 2, "")}}</div>
          </div>
        </div>
        <div :class="aActive ? 'c' : 'c c-shadow'" @click="aActive = false">
          <img src="@/assets/dashboard/全国销售毛利额(元).png" />

          <div class="text">
            <div class="key">全国销售毛利额(元)</div>
            <div class="value">{{util.formatMoney(head.profit, 2, "")}}</div>
          </div>
        </div>
        <div :class="aActive ? 'd' : 'd d-shadow'" @click="aActive = false">
          <img src="@/assets/dashboard/全国销售毛利率.png" />

          <div class="text">
            <div class="key">全国销售毛利率</div>
            <div class="value">
              {{util.formatMoney(head.profitRate * 100, 2, "")}}
              <span style="font-size: 20px">%</span>
            </div>
          </div>
        </div>

        <div class="a-active">
          <div v-show="aActive">
            <div class="line"></div>
            <div class="triangle">
              <div class="tri"></div>
            </div>
            <div class="text">全国销售数量</div>
          </div>
        </div>

        <div class="bcd-active">
          <div v-show="!aActive">
            <div class="line"></div>
            <div class="triangle">
              <div class="tri"></div>
            </div>
            <div class="text">全国销售额、毛利额、毛利率</div>
          </div>
        </div>
      </div>

      <div class="chart">
        <div v-if="aActive">
          <div class="menu">
            <div :class="isLine ? 'item active' : 'item'" @click="isLine = true">折线图</div>
            <div :class="isLine ? 'item' : 'item active'" @click="isLine = false">热力图</div>
          </div>
          <v-chart :options="lineOption" v-if="isLine" v-loading="loading"/>
          <v-chart :options="heatmapOption" v-else v-loading="loading"/>
        </div>
        <div v-else>
          <v-chart :options="barOption" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LatestUpdateTime from "@/components/dashboard/LatestUpdateTime";
import ScDatePicker from "./ScDatePicker";
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/calendar";
import echarts from "echarts";
import util from "@/plugins/util";

let unit = "";

export default {
  name: "ScSaleCommodity",
  components: {
    LatestUpdateTime,
    ScDatePicker,
    "v-chart": ECharts
  },
  props: {
    code: {
      type: String,
      required: true
    },
    categoryCode:{
        type: String,
        required: true
    },
  },
  data() {
    return {
      date: false,
      aActive: true,
      isLine: true,
      head: {},
      list: [],
      loading:true,
      lineOption: {
        grid: {
          top: 60,
          bottom: 60,
          right: 60,
          left: 100,
          containLabel: false,
          borderWidth: 0,
          borderColor: "#eee"
        },
        legend: {
          data: ["销售量", "平均售价"],
          x: "right"
        },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: [],
          axisLine: {
            lineStyle: {
              color: "rgba(0, 0, 0, 0.25)"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: "#848791"
          }
          // offset: 20
        },
        yAxis: [
          {
            type: "value",
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "rgba(0, 0, 0, 0.09)",
                type: "dashed"
              }
            },
            axisLabel: {
              color: "#848791",
              formatter: function(val) {
                return util.formatMoney(val, 2, "") + unit;
              }
            }
          },
          {
            type: "value",
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(0, 0, 0, 0.09)",
                type: "dashed"
              }
            },
            axisLabel: {
              color: "#848791",
              formatter: function(val) {
                return util.formatMoney(val, 2, "￥");
              }
            },
            // min: "dataMin",
            // max: "dataMax",
            // splitNumber: 5,
            // interval: 0.4,
            scale: true
          }
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#01B484"
            }
          },
          position: function(point, params, dom, rect, size) {
            return [point[0], "10%"];
          },
          backgroundColor: "#fff",
          padding: 15,
          textStyle: {
            color: "#999",
            fontSize: 12,
            fontFamily: "DIN Medium",
            lineHeight: 20
          },
          extraCssText: "box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);",
          formatter: function(params) {
            // console.log(params);
            const e = params[0].data.item;
            return (
              "<div style='color: #1B994F;'>销售量：</div>" +
              `<div style='color: #1B994F; height: 30px; line-height: 30px; font-size: 20px'>${util.formatMoney(
                e.quantity,
                2,
                ""
              )}${e.unit}</div>` +
              `<div style='color: #999'>销售额：<span style='color: #444;'>${util.formatMoney(
                e.amount,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>平均售价：<span style='color: #444;'>${util.formatMoney(
                e.price,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利额：<span style='color: #444;'>${util.formatMoney(
                e.profit,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利率：<span style='color: #444;'>${util.formatMoney(
                e.profitRate * 100,
                2,
                ""
              )}%</span></div>`
            );
          }
        },
        series: [
          {
            name: "销售量",
            data: [],
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#01B484"
            },
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#05AB81",
              borderColor: "#FFFFFF",
              borderWidth: 2
            },
            emphasis: {
              itemStyle: {
                borderWidth: 4
              }
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "rgba(1, 180, 132, 0.04)" // 0% 处的颜色
                  },
                  {
                    offset: 0,
                    color: "rgba(1, 180, 132, 0.49)" // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            name: "平均售价",
            data: [],
            type: "line",
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#4991FD",
              borderColor: "#FFFFFF",
              borderWidth: 2
            },
            emphasis: {
              itemStyle: {
                borderWidth: 4
              }
            },
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: "#4890FD"
            }
          }
        ]
      },
      barOption: {
        grid: {
          top: 60,
          bottom: 60,
          right: 60,
          left: 100,
          containLabel: false,
          borderWidth: 0,
          borderColor: "#eee"
        },
        legend: {
          data: ["销售额", "毛利额", "毛利率"],
          x: "right"
        },
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            lineStyle: {
              color: "rgba(0, 0, 0, 0.25)"
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          axisLabel: {
            color: "#848791"
          }
          // offset: 20
        },
        yAxis: [
          {
            // name: "销售额",
            type: "value",
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "rgba(0, 0, 0, 0.09)",
                type: "dashed"
              }
            },
            axisLabel: {
              color: "#848791",
              formatter: function(val) {
                return util.formatMoney(val, 2, "￥");
              }
            }
          },
          {
            // name: "毛利率",
            type: "value",
            show: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(0, 0, 0, 0.09)",
                type: "dashed"
              }
            },
            axisLabel: {
              color: "#848791",
              formatter: function(val) {
                return util.formatMoney(val, 2, "") + "%";
              }
            }
          }
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#01B484"
            }
          },
          position: function(point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0], "10%"];
          },
          backgroundColor: "#fff",
          padding: 15,
          textStyle: {
            color: "#999",
            fontSize: 12,
            lineHeight: 20,
            fontFamily: "DIN Medium"
          },
          extraCssText: "box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);",
          formatter: function(params) {
            // console.log(params);
            const e = params[0].data.item;
            return (
              "<div style='color: #1B994F;'>销售量：</div>" +
              `<div style='color: #1B994F; height: 30px; line-height: 30px; font-size: 20px'>${util.formatMoney(
                e.quantity,
                2,
                ""
              )}${e.unit}</div>` +
              `<div style='color: #999'>销售额：<span style='color: #444;'>${util.formatMoney(
                e.amount,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>平均售价：<span style='color: #444;'>${util.formatMoney(
                e.price,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利额：<span style='color: #444;'>${util.formatMoney(
                e.profit,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利率：<span style='color: #444;'>${util.formatMoney(
                e.profitRate * 100,
                2,
                ""
              )}%</span></div>`
            );
          }
        },
        series: [
          {
            name: "销售额",
            data: [],
            type: "bar",
            barWidth: 20,
            itemStyle: {
              normal: {
                color: "rgba(160, 225, 208, 1)"
              }
            }
          },
          {
            name: "毛利率",
            data: [],
            type: "line",
            symbol: "circle",
            symbolSize: 6,
            emphasis: {
              itemStyle: {
                borderWidth: 4
              }
            },
            yAxisIndex: 1,
            smooth: true,
            lineStyle: {
              color: "rgba(242, 131, 9, 1)"
            },
            itemStyle: {
              color: "rgba(242, 131, 9, 1)",
              borderWidth: 2,
              borderColor: "#ffffff"
            }
          },
          {
            name: "毛利额",
            data: [],
            type: "bar",
            barWidth: 20,
            barGap: "-100%",
            itemStyle: {
              normal: {
                color: "rgba(1, 180, 132, 1)"
              }
            }
          }
        ]
      },
      heatmapOption: {
        visualMap: {
          type: "piecewise",
          orient: "horizontal",
          left: "right",
          top: 0,
          minOpen: true,
          splitNumber: 5,
          min: 0,
          max: 100,
          precision: 0,
          formatter: function(min, max) {
            if (Number.isFinite(min)) {
              return `${Math.ceil(min)}${unit}~${Math.ceil(max)}${unit}`;
            } else {
              return `< ${Math.ceil(max)}${unit}`;
            }
          },
          textStyle: {
            color: "rgba(132, 135, 145, 1)"
          },
          inRange: {
            color: ["rgba(217, 255, 247, 1)", "rgba(0, 168, 134, 1)"]
          }
        },
        calendar: {
          cellSize: [30, 20],
          left: 55,
          top: 100,
          splitLine: {
            lineStyle: {
              color: "#eee"
            }
          },
          range: ["2019-04-01", "2019-11-30"],
          itemStyle: {
            normal: { borderWidth: 0 }
          },
          yearLabel: { show: false },
          monthLabel: {
            show: true,
            nameMap: "cn",
            margin: 20,
            color: "rgba(132, 135, 145, 1)"
          },
          dayLabel: {
            show: true,
            nameMap: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
            margin: 30,
            color: "rgba(132, 135, 145, 1)"
          }
        },
        tooltip: {
          trigger: "item",
          position: function(point, params, dom, rect, size) {
            return [point[0], "10%"];
          },
          backgroundColor: "#fff",
          padding: 15,
          textStyle: {
            color: "#999",
            fontSize: 12,
            fontFamily: "DIN Medium",
            lineHeight: 20
          },
          extraCssText: "box-shadow: 0px -1px 9px 0px rgba(68, 70, 86, 0.2);",
          formatter: function(params) {
            console.log(params);
            // const e = params[0].data.item;
            return (
              "<div style='color: #1B994F;'>销售量：</div>" +
              `<div style='color: #1B994F; height: 30px; line-height: 30px; font-size: 20px'>${util.formatMoney(
                e.quantity,
                2,
                ""
              )}${e.unit}</div>` +
              `<div style='color: #999'>销售额：<span style='color: #444;'>${util.formatMoney(
                e.amount,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>平均售价：<span style='color: #444;'>${util.formatMoney(
                e.price,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利额：<span style='color: #444;'>${util.formatMoney(
                e.profit,
                2,
                ""
              )}元</span></div>` +
              `<div style='color: #999'>毛利率：<span style='color: #444;'>${util.formatMoney(
                e.profitRate * 100,
                2,
                ""
              )}%</span></div>`
            );
          }
        },
        series: {
          type: "heatmap",
          coordinateSystem: "calendar",
          data: []
        }
      }
    };
  },
  created() {
    this.loadSaleData();
  },
  methods: {
    async loadSaleData() {
      const response = await this.ajax.doPost({
        packageName: "sc",
        className: "scSaleCommodity",
        methodName: "retrieve",
        params: {
          code: this.code,
          categoryCode:this.categoryCode,
          orderField: "saleDate",
          orderDirection: "desc",

          numPerPage: 240
        }
      });

      this.list = response.results;
      this.head = this.list[0];
      this.date = new Date(this.head.saleDate);

      unit = this.head.unit;

      const data = response.results.reverse();
      this.loading = false
      this.drawLine(data.slice(-23));
      this.drawBar(data.slice(-23));
      this.drawHeatmap(data);
    },
    drawLine(data) {
      this.lineOption.xAxis.data = data.map(e => {
        const date = new Date(e.saleDate);

        return `${date.getMonth() + 1}/${date.getDate()}`;
      });

      this.lineOption.series[0].data = data.map(e => {
        return {
          value: e.quantity,
          item: e
        };
      });

      this.lineOption.series[1].data = data.map(e => e.price);
    },
    drawBar(data) {
      this.barOption.xAxis.data = data.map(e => {
        const date = new Date(e.saleDate);

        return `${date.getMonth() + 1}/${date.getDate()}`;
      });

      this.barOption.series[0].data = data.map(e => {
        return {
          value: e.amount,
          item: e
        };
      });

      this.barOption.series[1].data = data.map(e => e.profitRate * 100);

      this.barOption.series[2].data = data.map(e => e.profit);
    },
    drawHeatmap(data) {
      data.sort((a, b) => a.quantity - b.quantity);

      const min = Math.max(data[0].quantity, 0);

      const max = data[data.length - 1].quantity;

      this.heatmapOption.visualMap.min = min;

      this.heatmapOption.visualMap.max = max;

      const last = new Date(this.date.getTime());
      last.setMonth(this.date.getMonth() + 1);
      last.setDate(0);
      const head = new Date(this.date.getTime());
      head.setMonth(this.date.getMonth() - 7);
      head.setDate(1);

      this.heatmapOption.calendar.range = [
        echarts.format.formatTime("yyyy-MM-dd", head),
        echarts.format.formatTime("yyyy-MM-dd", last)
      ];

      this.heatmapOption.series.data = data.map(e => {
        return [
          echarts.format.formatTime("yyyy-MM-dd", e.saleDate),
          e.quantity
          // e.amount
        ];
      });
    },
    onChange(date) {
      const result = this.list.find(e => {
        return (
          new Date(e.saleDate).toLocaleDateString() == date.toLocaleDateString()
        );
      });

      if (result) {
        this.head = result;
      } else {
        this.head = {};
      }
    }
  }
};
</script>

<style lang="scss">
.sc-sale-commodity {
  width: 100%;

  .inner {
    width: 1100px;
    margin: 0 auto;

    .chart {
      width: 100%;
      // height: 500px;

      > div {
        width: 100%;
        margin-top: 25px;
        position: relative;
        // height: 400px;
      }
    }

    .echarts {
      width: 100%;
      // height: 100%;
    }

    .title {
      margin: 20px 0;
      height: 40px;

      .left {
        float: left;

        img.icon {
          display: inline-block;
          width: 12px;
          height: 12px;

          margin-right: 10px;
        }

        div.name {
          display: inline-block;

          height: 28px;
          font-size: 20px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
        }
      }
      .right {
        float: right;
      }
    }

    .menu {
      width: 130px;
      display: inline-block;
      // margin: 15px auto;
      position: absolute;
      top: -5px;
      z-index: 1000;
      .item {
        width: 60px;
        height: 28px;
        display: inline-block;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(51, 51, 51, 1);
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        cursor: pointer;
      }
      .active {
        color: white;
        background: rgba(51, 51, 51, 1);
      }
    }

    .data-select {
      img {
        width: 80px;
      }
      .a,
      .b,
      .c,
      .d {
        width: 260px;
        height: 100px;
        display: inline-block;

        cursor: pointer;

        position: relative;

        .text {
          position: absolute;

          top: 20px;
          left: 65px;

          .key {
            height: 20px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 20px;
          }

          .value {
            margin-top: 8px;
            height: 36px;
            font-size: 30px;
            font-family: "DIN Medium";
            color: rgba(255, 255, 255, 1);
            line-height: 36px;
          }
        }
      }

      .a {
        background: linear-gradient(
          309deg,
          rgba(6, 202, 167, 1) 0%,
          rgba(1, 178, 128, 1) 100%
        );

        margin-right: 20px;
      }

      .a-shadow {
        box-shadow: 0px 2px 14px 0px rgba(5, 196, 157, 0.65);
      }

      .b {
        background: linear-gradient(
          309deg,
          rgba(54, 164, 248, 1) 0%,
          rgba(74, 142, 253, 1) 100%
        );

        margin-right: 20px;
      }

      .b-shadow {
        box-shadow: 0px 2px 10px 0px rgba(56, 162, 248, 0.47);
      }

      .c {
        background: linear-gradient(
          309deg,
          rgba(240, 110, 186, 1) 0%,
          rgba(255, 94, 136, 1) 100%
        );

        margin-right: 20px;
      }

      .c-shadow {
        box-shadow: 0px 2px 10px 0px rgba(243, 106, 175, 0.47);
      }

      .d {
        background: linear-gradient(
          309deg,
          rgba(247, 170, 22, 1) 0%,
          rgba(242, 124, 7, 1) 100%
        );
      }

      .d-shadow {
        box-shadow: 0px 2px 10px 0px rgba(245, 157, 18, 0.46);
      }

      .a-active {
        width: 260px;
        margin-right: 20px;

        display: inline-block;
        .line {
          margin-top: 10px;
          width: 260px;
          height: 3px;
          background: linear-gradient(
            309deg,
            rgba(6, 202, 167, 1) 0%,
            rgba(1, 178, 128, 1) 100%
          );
        }

        .triangle {
          .tri {
            position: relative;
            overflow: hidden;
            background: linear-gradient(
              309deg,
              rgba(6, 202, 167, 1) 0%,
              rgba(1, 178, 128, 1) 100%
            );
            width: 20px;
            height: 14px;
            margin: 5px auto;
          }
          .tri:before,
          .tri:after {
            position: absolute;
            content: "";
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 14px solid white;
          }
          .tri:before {
            margin-left: -10px;
          }
          .tri:after {
            margin-left: 10px;
          }
        }

        .text {
          font-size: 16px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 22px;

          text-align: center;
        }
      }

      .bcd-active {
        width: 820px;

        display: inline-block;
        .line {
          margin-top: 10px;
          width: 820px;
          height: 3px;
          background: linear-gradient(
            90deg,
            rgba(61, 157, 250, 1) 0%,
            rgba(245, 103, 167, 1) 53%,
            rgba(246, 166, 21, 1) 100%
          );
        }

        .triangle {
          .tri {
            position: relative;
            overflow: hidden;
            background: linear-gradient(
              90deg,
              rgba(61, 157, 250, 1) 0%,
              rgba(245, 103, 167, 1) 53%,
              rgba(246, 166, 21, 1) 100%
            );
            width: 20px;
            height: 14px;
            margin: 5px auto;
          }
          .tri:before,
          .tri:after {
            position: absolute;
            content: "";
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 14px solid white;
          }
          .tri:before {
            margin-left: -10px;
          }
          .tri:after {
            margin-left: 10px;
          }
        }

        .text {
          font-size: 16px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 22px;

          text-align: center;
        }
      }
    }
  }
}
</style>